
import React, { useState } from 'react'
import { Input, Tooltip } from 'antd'
import { setSelectionRange } from './tool'
import './index.css'

const Editor = ({initValue, onSubmit, onCancel}) => {
  const [value, setValue] = useState(initValue)
  const inputRef = React.useRef(null)
  const [isFocus, setIsFocus] = useState(false)
  const onFocus = () => {
    setIsFocus(true)
  }
  React.useEffect(() => {
    // inputRef focus
    setTimeout(() => {
      const textarea = inputRef.current.resizableTextArea?.textArea || inputRef.current
      textarea.focus()
      const len = value.length || textarea.value.length
      console.info('>>> inputRef.current.focus()', len)
      setSelectionRange(textarea, len, len)
    }, 100)
  }, [])
  return (
    <>
      <div
        className={[
          'absolute top-4px -left-12px',
          'w-full bg-[rgba(245,245,245,1)] border-1px border-[rgba(0,0,0,1) rounded-[12px]',
          'min-height-[56px] pl-11px pr-10px pt-[3px] pb-[3px] relative',
          'editor-focus',
        ]}
        style={{
          width: 'calc(100% + 22px)',
        }}
      >
        <Input.TextArea
          ref={inputRef}
          value={value}
          onChange={e => setValue(e.target.value)}
          maxLength={99999}
          autoSize={{ minRows: 1, maxRows: 4 }}
          variant='borderless'
          className={[
            '!bg-transparent !font-500 !leading-snug !resize-none break-all overflow-x-hidden nw-scrollbar !transition-none',
            '!text-primary !px-0 !py-0 !mb-0',
            value.length > 40 ? '!text-24px' : '!text-32px',
          ]}
          autoFocus
        />
        <div
          className='absolute w-80px h-34px right-10px bottom-8px bg-white flex flex-row flex-nowrap items-center justify-center rounded-6px border-1px border-[rgba(0,0,0,.1)]'
          style={{
            boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.12)'
          }}
        >
          <img onClick={() => onSubmit(value)} className="w-28px cursor-pointer" src="https://p4.ssl.qhimg.com/d/inn/5092edb5daf9/usermsg-submit.png" alt="" />
          <div className='w-1px h-12px bg-[rgba(0,0,0,.1)] ml-6px mr-6px'></div>
          <img onClick={onCancel} className="w-28px cursor-pointer" src="https://p5.ssl.qhimg.com/d/inn/5092edb5daf9/usermsg-close.png" alt="" />
        </div>
      </div>
    </>
  )
}

const EditableText = ({ initalText, children, submit, disabled }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [newText, setNewText] = useState(initalText)
  const [copySuccess, setCopySuccess] = useState(false)

  // share mcp 页面不显示编辑按钮
  const [isSharePage,] = useState(location.href.includes('share/mcp'))

  const handleEditClick = () => {
    if (disabled) return
    setIsEditing(true)
    setNewText(initalText)
  }
  const onCopy = (e) => {
    setCopySuccess(true)
    // 复制文本到剪贴板
    console.info('>>> 复制文本到剪贴板', initalText)
    navigator.clipboard.writeText(initalText)
    setTimeout(() => {
      setCopySuccess(false)
    }, 3000)
  }
  const onSubmit = (newText) => {
    setIsEditing(false)
    console.info('>>> 提交文本', newText)
    submit && submit(newText)
  }

  return (
    <div className="relative">
      {isEditing
      ? <Editor
          initValue={newText}
          onSubmit={(value) => onSubmit(value)}
          onCancel={() => setIsEditing(false)}
        />
      : (
        <section className="flex flex-row justify-between items-center group">
          {children}
          <div
            className={[
              'invisible group-hover:visible flex flex-row justify-center items-center',
              'border-1px border-[rgba(0,0,0,.1)] rounded-6px px-6px py-3px',
              'absolute right-0 bottom-8px bg-white',
            ]}
            style={{
              boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.12)'
            }}
          >
            {
            !isSharePage
            && <Tooltip title="编辑" placement="bottom" className={disabled ? 'cursor-default' : ''}>
                <div className='w-[28px] h-[28px] cursor-pointer group-1'>
                  {/* <img
                    src='https://p5.ssl.qhimg.com/d/inn/78b9ecc6bb05/usermsg-edit.png'
                    className='w-[100%] group-1-hover:opacity-0 opacity-100 transition-opacity duration-200 absolute top-0 left-0'
                    onClick={handleEditClick}
                  /> */}
                  <img
                    src='https://p5.ssl.qhimg.com/d/inn/8a5b55ca7ca0/usermsg-edit-hover.png'
                    className={[
                      'w-[100%] opacity-50 group-1-hover:opacity-100 transition-opacity duration-200',
                      disabled ? 'opacity-30 group-1-hover:opacity-30' : '',
                    ]}
                    onClick={handleEditClick}
                  />
                </div>
              </Tooltip>
            }
            <div className='w-1px h-[12px] bg-[rgba(0,0,0,.1)] ml-6px mr-6px'></div>
            <Tooltip title="复制" placement="bottom">
              <div className='w-[28px] h-[28px] cursor-pointer group-1'>
                {/* <img
                  src={
                    'https://p0.ssl.qhimg.com/d/inn/65a3be3cd5db/usermsg-cp2.png'
                  }
                  onClick={(e) => onCopy(e)}
                  className='w-[100%] group-1-hover:opacity-0 opacity-100 transition-opacity duration-200 absolute top-0 left-0'
                /> */}
                <img
                  src={
                    copySuccess
                      ? 'https://p2.ssl.qhimg.com/d/inn/d6a9592ee12b/usermsg-cped2.png'
                      : 'https://p4.ssl.qhimg.com/d/inn/8a5b55ca7ca0/usermsg-cp2-hover.png'
                  }
                  onClick={(e) => onCopy(e)}
                  className='w-[100%] opacity-50 group-1-hover:opacity-100 transition-opacity duration-200'
                />
              </div>
            </Tooltip>
          </div>
        </section>
      )}
    </div>
  )
}

export default EditableText
